





















import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import {IconTitle} from "@/types";

@Component
export default class IconMenu extends Vue {

    @Prop({required: true})
    public value!: IconTitle<any>

    @Prop({required: true})
    public items!: IconTitle<any>[]

    @Emit('input')
    private onItemClick(item: IconTitle<any>) {
        return item
    }

}
